(() => {
  const origin = 'https://www.hippiesips.com';
  const variantMap = {"48356850696363":"67577245794617","48356850729131":"67577245827385","48356850761899":"67577245860153","48356850794667":"67577245401401","48356850827435":"67577245434169","48356850860203":"67577245466937","48356850892971":"67577245499705","48356850925739":"67577245532473","48356850958507":"54291539788089","48356850991275":"54291539820857","48356851024043":"54291539853625","48356851056811":"54291539886393","48356851089579":"54284756058425","48356851122347":"54284756091193","48356851155115":"54310836044089","48356851187883":"54310836076857","48356851220651":"54463093047609","48356851286187":"54182124978489","48356851318955":"54182025331001","48356851351723":"54182021300537","48356851384491":"54182014320953","48356851417259":"53359497838905"};
  const productHandles = new Set(["hippie-drops-wholesale-boxes-cases","hippie-sips-wholesale-case-24-cans","gift-card","hippie-drops","strawberry-lemonade","lavender-lemonade","wild-berry-lemonade","mango-lemonade","variety-pack"]);
  const productHandle = path => path.match(/\/products\/([^/]+)\/?$/)?.[1];
  const isLocalCatalog = path => productHandles.has(productHandle(path)) || /^\/collections(?:\/[^/]+)?\/?$/.test(path);
  if (location.pathname !== '/' && !isLocalCatalog(location.pathname) && !window.Shopify?.designMode) {
    location.replace(origin + location.pathname + location.search);
    return;
  }
  const rewriteUrl = value => {
    const url = new URL(value, location.href);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    const storeHosts = [location.host, 'www.hippiesips.com', 'hippiesips.com', '2s0drj-9d.myshopify.com'];
    if (!storeHosts.includes(url.host)) return null;
    if (url.hash && url.pathname === location.pathname) return null;
    if (url.pathname === '/' || isLocalCatalog(url.pathname)) {
      url.host = location.host;
      url.protocol = location.protocol;
    } else {
      url.host = 'www.hippiesips.com';
      url.protocol = 'https:';
    }
    for (const key of ['preview_theme_id', '_ab', '_fd', '_sc']) url.searchParams.delete(key);
    return url.href === new URL(value, location.href).href ? null : url.href;
  };
  const updateLinks = () => {
    for (const link of document.querySelectorAll('a[href]')) {
      const value = link.getAttribute('href');
      if (!value || value.startsWith('#')) continue;
      const destination = rewriteUrl(value);
      if (destination) link.href = destination;
    }
  };
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('button[aria-label="Cart"],button[aria-label="Account"],button[aria-label="Search"]');
    if (control) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(origin + '/' + control.getAttribute('aria-label').toLowerCase());
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link) return;
    const destination = rewriteUrl(link.href);
    if (destination) link.href = destination;
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (action.pathname.includes('/cart/add')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      const id = variantMap[String(data.get('id'))];
      if (!id) {
        const card = form.closest('product-card, .product-card, .card');
        const productLink = card?.querySelector('a[href*="/products/"]');
        const handle = productHandle(productLink ? new URL(productLink.href).pathname : location.pathname);
        location.assign(origin + (handle ? '/products/' + handle : '/collections/all'));
        return;
      }
      const quantity = Math.max(1, Math.floor(Number(data.get('quantity')) || 1));
      const destination = origin + '/cart/' + id + ':' + quantity + '?storefront=true';
      if (window.Shopify?.designMode) window.open(destination, '_blank', 'noopener');
      else location.assign(destination);
      return;
    }
    if (action.pathname.includes('/search')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = new URL('/search', origin);
      url.searchParams.set('q', new FormData(form).get('q') || '');
      location.assign(url.href);
    } else if (action.pathname.includes('/cart')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(origin + '/cart');
    } else if (form.id === 'contact_form' || action.pathname.includes('/contact')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(origin + '/pages/newsletter');
    }
  }, true);
  const style = document.createElement('style');
  style.textContent = 'shopify-accelerated-checkout,.shopify-payment-button{display:none!important}';
  document.head.append(style);
  updateLinks();
  new MutationObserver(updateLinks).observe(document.body, {childList:true, subtree:true});
  if (!window.Shopify?.designMode && !sessionStorage.getItem('hippie-sips-age-confirmed')) {
    const gate = document.createElement('dialog');
    gate.setAttribute('aria-labelledby', 'hs-age-title');
    gate.innerHTML = '<h2 id="hs-age-title">Welcome!</h2><p>Please verify that you are 21 years of age or older to enter this site.</p><div><button type="button" data-accept>Agree — I am 21+</button><button type="button" data-decline>Disagree</button></div>';
    gate.style.cssText = 'max-width:440px;width:calc(100% - 40px);border:0;border-radius:18px;padding:32px;background:#fff8ed;color:#251537;text-align:center;box-shadow:0 24px 90px #0008';
    const style = document.createElement('style');
    style.textContent = 'dialog::backdrop{background:#0009}#hs-age-title{font-size:30px;margin:0 0 16px}dialog button[data-accept],dialog button[data-decline]{border:0;border-radius:24px;padding:12px 18px;margin:8px 4px;cursor:pointer;font:inherit}dialog button[data-accept]{background:#5a189a;color:#fff}dialog button[data-decline]{background:#ece4ee;color:#251537}';
    document.head.append(style);
    document.body.append(gate);
    gate.addEventListener('cancel', event => event.preventDefault());
    gate.querySelector('[data-accept]').addEventListener('click', () => {
      sessionStorage.setItem('hippie-sips-age-confirmed', '1');
      gate.close();
      gate.remove();
    });
    gate.querySelector('[data-decline]').addEventListener('click', () => location.assign('https://www.google.com'));
    gate.showModal();
  }
})();
